import { normalizeBasePath, normalizePath, pathForTab } from "../navigation.ts";
import { isFeatureTab, isHelpOnlyTopic, type HelpTopicId } from "./help-content.ts";

export function pathForHelpTopic(topic: HelpTopicId, basePath = ""): string {
  if (topic === "intro") {
    return pathForTab("help", basePath);
  }
  const base = normalizeBasePath(basePath);
  const path = `/help/${topic}`;
  return base ? `${base}${path}` : path;
}

export function helpTopicFromPath(pathname: string, basePath = ""): HelpTopicId {
  const base = normalizeBasePath(basePath);
  let path = pathname || "/";
  if (base) {
    if (path === base) {
      path = "/";
    } else if (path.startsWith(`${base}/`)) {
      path = path.slice(base.length);
    }
  }
  const normalized = normalizePath(path).toLowerCase();
  if (normalized === "/help") {
    return "intro";
  }
  if (normalized.startsWith("/help/")) {
    const slug = normalized.slice("/help/".length);
    if (isHelpOnlyTopic(slug) || isFeatureTab(slug)) {
      return slug;
    }
  }
  return "intro";
}

export function isHelpPath(pathname: string, basePath = ""): boolean {
  const base = normalizeBasePath(basePath);
  let path = pathname || "/";
  if (base && path.startsWith(`${base}/`)) {
    path = path.slice(base.length);
  }
  const normalized = normalizePath(path).toLowerCase();
  return normalized === "/help" || normalized.startsWith("/help/");
}
